// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"a3019a91","234":"3243cd8c","511":"34cfdc14"}[chunkId] + ".chunk.js";
};